import { OrderedMap } from 'immutable';
import { Action } from 'redux';
import Rubric from '../../models/Benefits/Rubric';
import {
    GET_RUBRICS_ERROR,
    GET_RUBRICS_REQUEST,
    GET_RUBRICS_RESPONSE, SET_ACTIVE_RUBRIC
} from '../../actions/Benefits/rubrics';

export interface RubricsState {
    rubrics: OrderedMap<number, Rubric>;
    loading: boolean;
    activeRubric: number;
}

const initialState: RubricsState = {
    rubrics: OrderedMap<number, Rubric>(),
    loading: false,
    activeRubric: 0
};

export const rubricsState = (state: RubricsState = initialState, action: Action): RubricsState => {
    switch (action.type) {
        case GET_RUBRICS_REQUEST: {
            return {
                ...state,
                loading: true
            };
        }
        case GET_RUBRICS_RESPONSE: {
            const rubrics = (action as any).response.result
                .reduce((prev: any, cur: any) => prev.set(cur.id, cur), OrderedMap<number, Rubric>());
            return {
                ...state,
                rubrics,
                loading: false
            };
        }
        case GET_RUBRICS_ERROR: {
            console.error((action as any).error);
            return {
                ...state,
                loading: false
            };
        }
        case SET_ACTIVE_RUBRIC: {
            return {
                ...state,
                activeRubric: (action as any).activeRubric
            };
        }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/Benefits/rubrics.ts